import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toProperCase } from '../../lib/utils';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from '../ui/dialog';
import { Plus } from 'lucide-react';

export function QuickCreatePartDialog({ 
  open, onOpenChange, data, setData, onConfirm 
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Plus className="h-5 w-5" />
            Quick Create Part
          </DialogTitle>
          <DialogDescription>
            Create a new part from this PO line item
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Internal Part No *</Label>
            <Input
              placeholder="e.g., BOLT-00123"
              value={data.internal_part_no || ''}
              onChange={(e) => setData({ ...data, internal_part_no: e.target.value })}
              data-testid="quick-create-partno"
            />
            <p className="text-xs text-muted-foreground">Leave blank to auto-generate</p>
          </div>
          <div className="space-y-2">
            <Label>Description</Label>
            <Input
              value={data.description || ''}
              onChange={(e) => setData({ ...data, description: e.target.value })}
              onBlur={(e) => e.target.value && setData(prev => ({ ...prev, description: toProperCase(e.target.value) }))}
            />
          </div>
          <div className="space-y-2">
            <Label>Part Type</Label>
            <Select 
              value={data.part_type || ''} 
              onValueChange={(v) => setData({ ...data, part_type: v })}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select type" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Bolt">Bolt</SelectItem>
                <SelectItem value="Nut">Nut</SelectItem>
                <SelectItem value="Screw">Screw</SelectItem>
                <SelectItem value="Washer">Washer</SelectItem>
                <SelectItem value="Stud">Stud</SelectItem>
                <SelectItem value="Other">Other</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onConfirm} data-testid="confirm-quick-create">
            <Plus className="h-4 w-4 mr-2" />
            Create Part
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
